// Company data
export const CompanyName = 'Ascari Building Contractors';
export const CompanyPhoneNumber = '07837685102';
export const ContactEmailAddress = 'hello@ascari-building-contractors.com';
export const DirectorName = 'Scott Laing';
export const LocationCity = 'Tavistock';
export const LocationCountry = 'United Kingdom';

// Address Constants
export const AddressLine1 = 'Ascari Building Contractors';
export const AddressLine2 = 'Tavistock';
export const AddressLine3 = 'Devon, United Kingdom';
export const AddressLine4 = '';
export const PostalCode = ''; 

export const CompanyTagLine = 'Reliable construction across Devon & Cornwall';
export const MainTitle = 'Expert Construction & Carpentry Services';
export const SubtitleMain = 'Quality craftsmanship for all aspects of building work';
export const SubtitleSecondary = `Over 20 Years Experience?`;

export const KeyowrdsPages =
  'Ascari Building Contractors, construction, carpentry, Devon builders, Cornwall construction, home renovations, extensions, roofing, flooring, bespoke carpentry, general building, Tavistock builders';

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 10000;
export const CookiePolicyName = 'CookiePolicy';

// Pages
export const HOME_PAGE_URL = '/';
export const CARPENTRY_PAGE_URL = '/carpentry';
export const BATHROOMS_PAGE_URL = '/bathrooms';
export const GROUNDWORKS_PAGE_URL = '/groundworks';
export const BUILDING_WORK_PAGE_URL = '/building-work';
export const CONTACT_PAGE_URL = '/contact';
export const RESET_PASS_PAGE_URL = '/reset-password';
export const POLICIES_PAGE_URL = '/user-agreements';
export const ADMIN_PAGE_URL = '/admin';
export const LOGIN_PAGE_URL = '/login';
export const SIGN_UP_PAGE_URL = '/sign-up';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// Blog routes
export const BLOG_PAGE_URL = '/blog';
export const BLOG_POST_PAGE_URL = '/blog';
export const CREATE_BLOG_POST_PAGE_URL = '/blog/create-new-post';
export const EDIT_BLOG_POST_PAGE_URL = '/blog/edit/postId';

// Blog API routes
export const GET_BLOG_POSTS_API = '/blog/get-all-blog-posts';
export const GET_BLOG_POST_BY_TITLE_API = '/blog/get-all-blog-posts';

// URL
export const FULL_BUSINESS_URL = 'https://www.ascari-building-contractors.co.uk';
export const SHORT_BUSINESS_URL = 'ascari-building-contractors.co.uk';
export const DISPLAY_BUSINESS_URL = 'www.ascari-building-contractors.co.uk';

// API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
export const SUBMIT_CONTACT_FORM_API = '/contact/submit-form'; // userId

// Bot Data
export const BotName = 'Jerry'

// Social Media Services
export const FACEBOOK_SERVICE = 'facebook';
export const INSTAGRAM_SERVICE = 'instagram';
export const GOOGLE_SERVICE = 'google';
export const GITHUB_SERVICE = 'github';
export const APPLE_SERVICE = 'apple';
export const X_SERVICE = 'x';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

export const FACEBOOK_NAME = 'ascari-building-contractors';
export const INSTAGRAM_NAME = 'ascari-building-contractors';
export const LINKEDIN_NAME = 'ascari-building-contractors';

export const FACEBOOK_BUSINESS_URL = `https://www.facebook.com/company/ascari-building-contractors`;
export const INSTAGRAM_BUSINESS_URL = `https://instagram.com/ascari-building-contractors`;
export const LINKEDIN_BUSINESS_URL = `https://www.linkedin.com/ascari-building-contractors`;
export const GITHUB_BUSINESS_URL = `https://www.github.com/ascari-building-contractors`;
export const GOOGLE_BUSINESS_URL = `https://www.google.com/ascari-building-contractors`;